import { RouteNode } from "@Xpresso/routes/routes";
import {
    AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL
} from "../../common/logic/user-level";

export const ProgramDefaultsRoutes: Record<string, RouteNode> = {
    "program-defaults": {
        path: "/program-defaults",
        component: "ProgramDefaultsRerouter",
        children: {
            "apm-prefs": {
                path: "/apm-prefs",
                component: "ApmPrefsRerouter",
                children: {
                    ":product": {
                        path: "/:product",
                        component: "ApmPrefsRoute",
                        userLevels: [AGENT_LEVEL],
                    }
                }
            },
            "scheduled-campaigns": {
                path: "/scheduled-campaigns",
                component: "ScheduledCampaignsRoute",
                userLevels: [AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL],
                children: {
                    ":step": {
                        path: "/:step",
                        component: "ScheduledCampaignsRoute",
                        userLevels: [AGENT_LEVEL, BRANCH_LEVEL, COMPANY_LEVEL],
                    }
                }
            },
        },
    },
};